<template>
	<!-- eslint-disable vue/no-v-html -->
	<q-layout-footer class="no-shadow justify-center">
		<div style="width: 1140px; max-width: 90vw; margin: 0 auto">
			<div id="signature" class="row q-mb-xl justify-center">
				<div id="signature-image" class="col-xs-12 col-md-auto signature">
					<img :src="signatureInformation.avatar_path" :alt="signatureInformation.full_name" />
				</div>
				<div id="signature-text" class="col-auto self-end signature">
					<div class="q-body-1" v-html="signatureInformation.signature"></div>
				</div>
			</div>
			<div id="imprint" class="row justify-center">
				<div id="imprint-image" class="col-4 col-md-3 col-lg-2 imprint">
					<a href="http://www.simpleshow.com" target="_blank" rel="noopener noreferrer">
						<img src="/images/cockpit/simpleshow.svg" alt />
					</a>
				</div>
				<div id="imprint-links" class="col-12 text-center">
					<h5 class="q-mt-sm">
						<a href="https://simpleshow.com/imprint/" target="_blank" rel="noopener noreferrer">imprint</a> | <a href="https://simpleshow.com/privacy-policy/" target="_blank" rel="noopener noreferrer">privacy policy</a> |
						<a href="http://simpleshow.com/#contact-form" target="_blank" rel="noopener noreferrer">contact</a>
					</h5>
				</div>
			</div>
			<div class="row justify-center"></div>
		</div>
	</q-layout-footer>
</template>

<script>
	export default {
		name: 'GuestPlaylistFooter',
		props: {
			signatureInformation: {
				type: Object,
				default() {
					return {
						avatar_path: '',
						full_name: '',
						signature: ''
					};
				}
			}
		}
	};
</script>
